// Libs
import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
// CSS
import './styles.scss'

// Components/Containers
import TopMessage from '../../components/TopMessage'
import NotSupported from '../../components/NotSupported'
import PopUp from '../PopUp'

import { daysDifference } from '../../constants/validate'
import { changePopUp } from '../PopUp/actions'

class App extends Component {
  state = {
    supported: true,
    copied: false
  }

  UNSAFE_componentWillMount() {
    var ua = window.navigator.userAgent
    var msie = ua.indexOf("MSIE ")
    const { user, changePopUp } = this.props
    const pathname = window.location.pathname

    // If Internet Explorer
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      this.setState({ supported: false })
    }

    if (!_.isEmpty(user)) {
      if (user.groupExpiredPassword && user.lawfirm === null && !user.admin && pathname !== '/login' && pathname !== '/') {
        if (user.updatedPassword === null || daysDifference(user.updatedPassword) >= 90) {
          changePopUp(true, 'amil')
        }
      }
    }
  }

  handleCopy = () => {
    const url = 'http://google.com.br'

    try {
      let textarea = document.createElement("textarea")
      textarea.innerHTML = window.location.href
      let copied = textarea.createTextRange()
      copied.execCommand("copy")
      textarea.remove()

      this.setState({ copied: true })
    } catch (err) {
      console.error(err)

      this.setState({ copied: false })
    }
  }

  render() {
    const { children } = this.props
    const { supported, copied } = this.state
    const { handleCopy } = this

    return (
      <div className="app">
        {supported && children}
        {!supported &&
          <NotSupported
            copied={copied}
            onCopy={handleCopy}>
            Error
          </NotSupported>
        }
        {/* TODO: send PopUp to Auth and switch Tour for PopUp */}
        <PopUp />
      </div>
    )
  }
}
App = connect(
  (state) => ({
    user: state.auth.user,
  }), { changePopUp })(App)

export default App
